import React from 'react'
import { ChangePasswordForm } from '../forms'

const ChangePasswordPage = () => (
  <div>
    <p>Change password:</p>
    <ChangePasswordForm />
  </div>
)

export default ChangePasswordPage



// WEBPACK FOOTER //
// ./src/browser/pages/ChangePasswordPage.js